import Header from "./components/Header";
import { Route, Routes, useLocation } from "react-router-dom";
import Swap from "./pages/Swap";
import Home from "./pages/Home";
import Token from "./pages/Token";
import { useState } from "react";

// import WebSocketContext from './contexts/WebSocket';
// import Staking from "./pages/Staking";
import useSetReferrerFromUrl from "./hooks/useSetReferrerFromUrl";
// import Stakinglong from "./pages/Stakinglong";
// import Staking4No1 from "./pages/Staking4No1";
import Profile from "./pages/Profile";
import Announcements from "./pages/Announcements";
import BottomNav from "./components/BottomNav";
import Liquidity from "./pages/Liquidity/Liquidity.tsx";
import ImportLiquidityPool from "./pages/Liquidity/import-liquidity-pool.tsx";
import Footer from "./components/Footer";
import Mining from "./pages/Mining";
import C2C from "./pages/C2C";
import CreatePair from "./pages/Liquidity/create-pair.tsx";
import RemovePair from "./pages/Liquidity/remove-pair.tsx";
function App() {
  useSetReferrerFromUrl()
  const [isToastOpen, setIsToastOpen] = useState(true);
  const { pathname } = useLocation();
  return (
    <>
      <Header />
      <main className={'relative flex-grow min-h-[calc(100vh_-_65px_-_164px)] md:min-h-[calc(100vh_-_65px_-_72px)]'} >
        <Routes>
          <Route path="/" element={<Swap />} />
          <Route path="/application" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/launchpad" element={<C2C />} />
          <Route path="/mining" element={<Mining/>} />
          <Route path="/Liquidity" element={<Liquidity />} />
          <Route path="/trade/import-liquidity-pool/" element={<ImportLiquidityPool />} />
          <Route path="/trade/create-pair/" element={<CreatePair />} />
          <Route path="/trade/remove-pair/:tokenAAddress/:tokenBAddress/:pairAddress" element={<RemovePair />} />
          <Route path="/trade" element={<Liquidity />} />
          
        </Routes>

      </main>
      <Footer />
      <BottomNav />
    </>
  );
}

export default App;

